<template lang="pug">
    .map-box-key(v-if="k >= 0")
        h4 {{ $t('UPS') }}
        el-form-item(:label="$t('Account Number (6 digits)')")
            el-input(type="input" v-model="public" maxlength="255" show-word-limit)
        el-button(@click="upsLogout" type="primary" :disabled="upstoken==''") {{ $t('UPS logout') }}
        p.hint(v-if="upstoken==''") {{ $t('UPS not logged in. Login happens while shipping packages.')  }}
</template>

<i18n>
{
    "de": {
        "UPS": "UPS",
        "Account Number (6 digits)": "Account Nr. (sechsstellig)",
        "UPS logout": "UPS ausloggen",
        "UPS not logged in. Login happens while shipping packages.": "Nicht mit UPS eingeloggt. Der Login wird während des Versendens durchgeführt.",
        "Logout successfully": "Logout erfolgreich"
    }
}
</i18n>

<script>

import _ from 'lodash'
// import { mapGetters } from 'vuex'
import store from '@/store'

export default {
    name: 'UpsKeys',
    props: {
        cms: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            key: 'ups-account-nr',
            upstoken: ''
        }
    },
    methods: {
        upsLogout() {
            localStorage.removeItem('upstoken');
            this.upstoken = '';

            this.$notify.success({
                title: this.$t('Logout successfully'),
                iconClass: 'fas el-icon-fa-check',
                position: 'bottom-left',
                customClass: 'dark',
                duration: 8000,
            })
        }
    },
    computed: {
        k() {
            // get the index of cms related api key with identifier 'mapbox'
            const apiKeys = _.get(this.cms, 'apiKeys') || []
            return _.findIndex(apiKeys, apiKey => apiKey.key === this.key)
        },
        public: {
            get() {
                return this.cms.apiKeys[this.k].public
            },
            set(value) {
                const data = {
                    index: this.k,
                    field: 'public',
                    value
                }
                store.commit('settings/form/cmsApiKey', data)
            }
        },
    },
    mounted() {
        if (this.k < 0) store.commit('settings/form/addCmsApiKey', this.key)

        //needed because localStorage is not reactive
        if (localStorage.getItem('upstoken') != null) {
            this.upstoken = localStorage.getItem('upstoken');
        }

    }
}
</script>

<style lang="sass" scoped>
.map-box-key
    padding-left: 12px
    position: relative
    &:before
        content: ''
        position: absolute
        left: 0
        top: 0
        bottom: 0
        width: 4px
        background: rgba($color-grey-text, .2)
        border-radius: 6px
    h4
        color: $color-grey-text
.hint
    margin-top: 12px
    font-size: 12px
</style>
